<template>
    <div class="know-how-cl">
        <title-screen title ="2"></title-screen>
        <div class="know-how-topics border-radius">
            <p style="font-size: 23px">トピックス</p>
            <ul>
              <li v-for="topic in topicData" :key="topic.id">
                <i class="el-icon-arrow-right"></i><a @click="handleClickRefer(topic.id)" style="font-size: 20px">{{ topic.name }}</a>
              </li>
            </ul>
        </div>
        <ul class="category-pc">
            <li class="category-item" v-for="item in dataKnowHowShow" :key="item.categoryId">
                <div class="content-sub-category  border-bottom-category">
                  <div style="display: inline-flex">
                    <div style="margin-top: 5px">
                      <svg x="0" y="0" width="24" height="24" style="overflow: hidden;" clip-path="url(#cp_undefined26fa03ee)"><image x="0" y="0" width="24" height="24" preserveAspectRatio="none" xlink:href="@/images/common/icon-category.png"></image></svg>
                    </div>
                    <p>
                      {{item.categoryName}}
                    </p>
                  </div>
                    <div class="scroll-category">
                        <ul class="sub-category">
                            <li v-for="itemChild in item.documents" :key="itemChild.id">
                                <i class="el-icon-arrow-right"></i><a @click="handleClickRefer(itemChild.id)">{{itemChild.name}}</a>
                            </li>
                        </ul>
                    </div>
                    <p v-if="item.showDown > 3 && item.indexShowMsg < item.showDown" class="see-the-list">
                        <a @click="showCategory(item.categoryId)">一覧を見る</a>
                    </p>
                </div>
            </li>
        </ul>
        <ul class="category-sp">
            <li class="category-item" v-for="item in dataKnowHowShowSp" :key="item.categoryId">
                <div class="content-sub-category  border-bottom-category">
                    <div style="display: inline-flex">
                        <div style="margin-top: 5px">
                            <svg x="0" y="0" width="24" height="24" style="overflow: hidden;" clip-path="url(#cp_undefined26fa03ee)"><image x="0" y="0" width="24" height="24" preserveAspectRatio="none" xlink:href="@/images/common/icon-category.png"></image></svg>
                        </div>
                        <p>
                            {{item.categoryName}}
                        </p>
                    </div>
                    <div class="scroll-category">
                        <ul class="sub-category">
                            <li v-for="itemChild in item.documents" :key="itemChild.id">
                                <i class="el-icon-arrow-right"></i><a @click="handleClickRefer(itemChild.id)">{{itemChild.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
        <div class="clear"></div>
    </div>
 </template>
<script>
import knowhow from '@/api/knowhow/know-how-cl.js'
import TitleScreen from '@/components/common/TitleScreen'
export default {
  components: {
      'title-screen': TitleScreen
  },
  data () {
    return {
      dataKnowHowCategory: [],
      dataKnowHowShow: [],
      dataKnowHowShowSp: [],
      countMsg: 3,
      topicData: []
    }
  },
  mounted () {
    let hieghtLi = this._$('.know-how li.know-how-content').height()
    let hieghTtitle = this._$('.know-how-item .know-how-item-tittle').height()
    this._$('.know-how-item .know-how-item-content').css('height', hieghtLi - hieghTtitle)
  },
  methods: {
    getListData () {
      knowhow.searchKnowHow().then(response => {
        this.dataKnowHowCategory = response.data.data
        this.dataCategory(this.dataKnowHowCategory)
      })
    },
    handleClickRefer (id) {
      this.$router.push({ name: 'categoryDetail', params: { id: id } })
    },
    showCategory (id) {
        let allData = this.dataKnowHowCategory
        let _this = this
        allData.forEach(function (item, index) {
            if (item.categoryId === id) {
                let document = []
                item.documents.forEach(function (doc, indexDoc) {
                    document.push({ 'id': doc.id, 'name': doc.name })
                })
                _this.dataKnowHowShow[index].indexShowMsg = item.documents.length
                if (document.length > 0) {
                    _this.dataKnowHowShow[index].documents = []
                    _this.dataKnowHowShow[index].documents = document
                } else {
                    _this.dataCategory(allData)
                }
            }
        })
    },
    dataCategory (data) {
        let _this = this
        this.dataKnowHowShow = []
        this.dataKnowHowShowSp = []
        this.topicData = []
        data.forEach(function (item, index) {
            let document = []
            let documentSp = []
            let record = 0
            item.documents.forEach(function (doc, indexDoc) {
                documentSp.push({ 'id': doc.id, 'name': doc.name })
                record++
                if (record <= 3) {
                    document.push({ 'id': doc.id, 'name': doc.name })
                }
                if (doc.isTopic) _this.topicData.push(doc)
            })
            _this.dataKnowHowShow.push({ 'categoryId': item.categoryId, 'categoryName': item.categoryName, 'documents': document, 'showDown': item.documents.length, 'indexShowMsg': 3 })
            _this.dataKnowHowShowSp.push({ 'categoryId': item.categoryId, 'categoryName': item.categoryName, 'documents': documentSp, 'showDown': item.documents.length })
        })
    }
  },
  created () {
    this.getListData()
  }
}
</script>
<style>
    @import "../../../../assets/css/custom.css";
    .know-how-cl {
        font-weight: bold;
    }
    .know-how-cl ul{
        width: 100%;
        clear: both;
    }
    .know-how-cl ul li.category-item {
        width: 50%;
        float: left;
        padding: 5%;
    }
    .clear {
        clear: left;
    }
    .document-name ul li {
        padding: 5px;
    }
    .know-how-item-content ul li div.document-name ul li .child-isNew a{
        background: #a5272a;
        color: #fff;
        font-size: 12px;
        padding: 5px;
        border-radius: 5px;
    }
    .know-how-item-content ul li div.document-name ul li .child-isNew p{
        background: none;
        border-radius: 5px;
        color: #fff;
        display: inline-block;
        font-size: 10px;

    }
    .know-how-item-content ul li div.document-name ul li .child-isNew a:hover{
        cursor: default;
    }
    .category-pc {
        display: block;
    }
    .category-sp {
        display: none;
    }
    @media screen and (max-width:768px){
        .category-item {
            clear: both;
            width: 90%;
            margin: 5px auto;
            float: none;
            max-width:768px
        }
        .know-how-cl ul li.category-item {
            width: 100%;
        }
    }
    @media screen and (max-width:450px){
        .category-pc {
            display: none;
        }
        .category-sp {
            display: block;
        }
        .know-how-cl .category-item .content-sub-category {
            height: auto !important;
        }
        .content-sub-category .scroll-category {
            max-height: unset !important;
            padding-bottom: 20px;
            overflow-y: unset !important
        }
    }
    .know-how-topics {
        width: 90%;
        margin: 0 auto;
        background: #fffdf7;
/*
        -webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
        -moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
        box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
*/
        border: 2px solid #d6d6d6;
    }
    .know-how-topics ul {
        padding: 2% 15% 5% 15%;
    }
    .know-how-topics .el-icon-arrow-right {
        font-weight: bold;
    }
    .know-how-topics p {
        text-align: center;
        padding-top: 2%;
    }
    .know-how-cl .category-item p.see-the-list{
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .know-how-cl .category-item p.see-the-list a{
      font-size: 16px!important;
    }
    .border-bottom-category {
        border-bottom: 2px solid #929292;
    }
    .know-how-cl .sub-category li{
        padding-left: 24px;
        display: flex;
        align-items: center;
        word-break: break-all;
        font-size: 14px;
        padding-bottom: 10px;
    }
    .know-how-cl .sub-category li i {
        flex-grow: 1;
        max-width: 24px;
    }
    .know-how-cl .sub-category li a {
        flex-grow: 2;
        font-size: 16px;
    }
    .know-how-cl .sub-category li a:hover,
    .know-how-cl .category-item .see-the-list a:hover{
        text-decoration: underline;
        cursor: pointer;
    }
    .know-how-cl .category-item .content-sub-category {
        position: relative;
        height: 200px;
    }
    .know-how-cl .category-item .content-sub-category p {
        padding-bottom: 10px;
    }
    .know-how-cl .category-item .content-sub-category p,
    .know-how-cl .category-item .content-sub-category p a,
    .know-how-topics p{
        font-size: 20px;
    }
    .know-how-topics ul li {
        font-size: 14px;
        padding: 1px;
    }
    .know-how-topics ul li a:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    .scroll-category {
        overflow-y: auto;
        max-height: 100px;
    }
</style>
